import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Package, FolderOpen, ShoppingCart, LogOut, Warehouse, Users, Ticket, CalendarOff, Building2, Clock, Send, ShoppingBag, MapPin } from "lucide-react";
import { toast } from "sonner";

const AdminLayout = ({ children, title }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_email");
    toast.success("Logout effettuato");
    navigate("/admin/login");
  };

  const navItems = [
    { path: "/admin", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/admin/ordini", icon: ShoppingCart, label: "Ordini" },
    { path: "/admin/disponibilita", icon: CalendarOff, label: "Disponibilità" },
    { path: "/admin/prodotti", icon: Package, label: "Prodotti" },
    { path: "/admin/categorie", icon: FolderOpen, label: "Categorie" },
    { path: "/admin/magazzino", icon: Warehouse, label: "Magazzino" },
    { path: "/admin/scadenze", icon: Clock, label: "Scadenze" },
    { path: "/admin/clienti", icon: Users, label: "Clienti" },
    { path: "/admin/aziende-partner", icon: Building2, label: "Aziende Partner" },
    { path: "/admin/codici-sconto", icon: Ticket, label: "Codici Sconto" },
    { path: "/admin/ordine-rapido", icon: Send, label: "Ordine Rapido" },
    { path: "/admin/liste-spesa", icon: ShoppingBag, label: "Clienti Speciali" },
    { path: "/admin/comuni", icon: MapPin, label: "Comuni Consegna" },
  ];

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="bg-zinc-900 border-b lg:border-b-0 lg:border-r border-zinc-800 lg:w-64">
        <div className="p-6">
          <img
            src="https://customer-assets.emergentagent.com/job_pregiato-pwa/artifacts/nccyaily_LOGO.png"
            alt="PREGIATO"
            className="h-12 w-auto mb-6"
          />
          <p className="text-zinc-400 text-sm">Admin Panel</p>
        </div>

        <nav className="px-3 pb-6" data-testid="admin-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg mb-2 transition-all ${
                  isActive
                    ? "bg-green-500 text-black font-semibold"
                    : "text-zinc-400 hover:bg-zinc-800 hover:text-white"
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <Icon className="w-5 h-5" />
                {item.label}
              </Link>
            );
          })}

          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg mt-4 text-red-500 hover:bg-red-500 hover:text-white transition-all"
            data-testid="logout-button"
          >
            <LogOut className="w-5 h-5" />
            Logout
          </button>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-6 lg:p-8" data-testid="admin-main">
        {title && (
          <h1 className="text-4xl font-bold text-white mb-8" data-testid="admin-page-title">{title}</h1>
        )}
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
